import React from 'react'
import { Link } from 'react-router-dom'
import { Mobile } from '../../shared/responsive-breakpoints'

const HomeCategoriesItem = ({
  bannerButtonText,
  category,
  isActive,
  changeActiveCategory,
  selectCategory,
}) => {
  const handleClick = () => {
    changeActiveCategory(category)
  }

  return (
    <li
      className={
        isActive
          ? 'dealmed-home-categories__item dealmed-home-categories__item--active'
          : 'dealmed-home-categories__item'
      }
    >
      <button
        className={
          isActive
            ? 'dealmed-home-categories__button dealmed-home-categories__button--active'
            : 'dealmed-home-categories__button'
        }
        type="button"
        onClick={handleClick}
      >
        <img
          src={category.categoryImage.fields.file.url}
          className="dealmed-home-categories__icon"
          alt=""
        />
        <p className="dealmed-home-categories__title">{category.categoryTitle}</p>
      </button>
      <Mobile>
        <div
          className={
            isActive
              ? 'dealmed-home-categories__content dealmed-home-categories__content--active'
              : 'dealmed-home-categories__content'
          }
        >
          <div className="dealmed-home-categories__wrapper">
            <p className="dealmed-home-categories__text">{category.categoryText}</p>
            {category.categoryData ? (
              <Link
                onClick={() => selectCategory(category.categoryData)}
                to={{ pathname: `/category/${category.categoryData.urlComponent}` }}
                className="dealmed-home-categories__link"
              >
                {bannerButtonText}
              </Link>
            ) : null}
          </div>
        </div>
      </Mobile>
    </li>
  )
}

export default HomeCategoriesItem
